<template>
  <div class="lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="AddNewDeviceNoHub-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="AddNewDeviceNoHub-main-wrapper lxn-pos-rel lxn-margin-auto lxn-border-round">
      <WrapperSvgTitleText>
        <template v-slot:svg>
          <svg viewBox="0 0 113.39 113.39">
            <g transform="translate(175.085 -251.936)">
              <path class="AddNewDeviceNoHub-st0" d="M-154.39,251.94h72c11.43,0,20.69,9.26,20.69,20.69v72c0,11.43-9.26,20.69-20.69,20.69h-72c-11.43,0-20.69-9.26-20.69-20.69v-72C-175.09,261.2-165.82,251.94-154.39,251.94z"/>
              <path class="AddNewDeviceNoHub-st1" d="M-77.48,353.99c0,0-15.68,2.86-40.91,2.86s-40.91-2.86-40.91-2.86c-2.46,0-4.45-1.99-4.45-4.45c0,0-2.86-15.68-2.86-40.91s2.86-40.91,2.86-40.91c0-2.46,1.99-4.45,4.45-4.45h0c0,0,15.68-2.86,40.91-2.86s40.91,2.86,40.91,2.86c2.46,0,4.45,1.99,4.45,4.45l0,0c0,0,2.86,15.68,2.86,40.91s-2.86,40.91-2.86,40.91C-73.03,352-75.02,353.99-77.48,353.99C-77.48,353.99-77.48,353.99-77.48,353.99z"/>
            </g>
            <path class="AddNewDeviceNoHub-st2" d="M70.78,75.27c-6.01,10.51-21.16,10.51-27.18,0l-11.22-19.6c-5.98-10.44,1.56-23.44,13.59-23.44h22.44c12.03,0,19.56,13,13.59,23.44L70.78,75.27z"/>
            <rect x="53.97" y="65.85" class="AddNewDeviceNoHub-st3" width="6.45" height="6.45"/>
            <rect x="53.97" y="40.06" class="AddNewDeviceNoHub-st3" width="6.45" height="19.34"/>
          </svg>
        </template>
        <template v-slot:title>
          {{$store.getters.language.texts.AddDeviceNoHub_title}}
        </template>
        <template v-slot:text>
          {{$store.getters.language.texts.AddDeviceNoHub_text}}
        </template>
      </WrapperSvgTitleText>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import WrapperSvgTitleText from '@/components/addNewDevice/WrapperSvgTitleText.vue'


export default {
  name: 'AddNewDeviceNoHub',
  components: {
    CustomCurve,
    TopNav,
    WrapperSvgTitleText
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
  }
}
</script>

<style>
  .AddNewDeviceNoHub-topCurve-wrapper {
    height: 200px;
  }
  .AddNewDeviceNoHub-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 1;
    background-color: #ffffff;
  }
	.AddNewDeviceNoHub-st0 {
    fill: #ECECEC;
  }
	.AddNewDeviceNoHub-st1 {
    fill: #53636C;
  }
	.AddNewDeviceNoHub-st2 {
    fill: #FFFFFF;
  }
	.AddNewDeviceNoHub-st3 {
    fill: #F36C4F;
  }
</style>
